<template>
  <el-dialog
    class="dialog-wrapper measured-values"
    visible
    show-close
    :close-on-click-modal="false"
    :append-to-body="appendToBody"
    @close="abortInsert"
  >
    <ContentHeader
      slot="title"
      :title="$t('sampleDetails.measuredValues.title')"
    />
    <ValidationObserver
      ref="expectedValuesForm"
      v-slot="{ handleSubmit, invalid }"
    >
      <el-form
        ref="form"
        label-position="top"
      >
        <FormOperationValue
          :operationValue="formData"
          :sample="sample"
          :operation="currentOperation"
          check-value
          @update:specification="updateSpecification"
        />

        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortInsert"
          >
            {{ $t('global.cancel') }}
          </el-button>
          <el-button
            type="primary"
            native-type="submit"
            :disabled="invalid || submitInvalid"
            @click.prevent="handleSubmit(insertValues)"
          >
            {{ $t('global.confirm') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import moment from 'moment';

  import { samplesApi } from '@/api';

  import FormOperationValue from '@/components/FormOperationValue.vue';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';

  const initialData = {
    value: '',
    LD: '',
    LQ: '',
    U: '',
    analysisStart: '',
    analysisEnd: '',
    symbol: '',
    symbolLot: '',
    measureId: null,
    measure: null,
    notes: '',
    recoveryFactor: null,
  };

  const initialSpecificationData = {
    type: 'None',
    selectionValues: [],
    decimalDigits: null,
    minRange: null,
    maxRange: null,
    isMinRangeInclusive: null,
    isMaxRangeInclusive: null,
    specificationValue: null,
  };

  export default {
    name: 'InsertMeasuredValues',
    components: {
      FormOperationValue,
      ContentHeader,
      FormButtons,
    },
    props: {
      labSampleAnalysisId: { type: Number, required: true },
      operationId: { type: Number, required: true },
      currentValues: { type: Object },
      currentOperation: { type: Object },
      sample: { type: Object, required: true },
      appendToBody: { type: Boolean, default: false },
    },
    data() {
      return {
        formData: { ...initialData },
        specification: { ...initialSpecificationData },
      };
    },
    computed: {
      submitInvalid() {
        if (
          this.formData.analysisEnd !== '' &&
          this.formData.analysisEnd !== null
        ) {
          if (
            this.formData.value === undefined ||
            this.formData.value === null ||
            this.formData.value === ''
          ) {
            return true;
          }
          return false;
        }
        if (this.formData.value !== '') {
          if (
            this.formData.analysisEnd === '' ||
            this.formData.analysisEnd === null
          ) {
            return true;
          }
          return false;
        }
        return false;
      },
    },
    methods: {
      async insertValues() {
        try {
          const { measure, ...formData } = this.formData;
          const { type, minRange, maxRange, ...specification } =
            this.specification;
          const valuesData = {
            ...formData,
            recoveryFactor: this.parseDecimal(formData.recoveryFactor),
            ...specification,
            specificationType: type,
            minRange,
            maxRange,
            analysisStart: moment
              .utc(formData.analysisStart)
              .startOf('day')
              .toDate(),
            analysisEnd: moment
              .utc(formData.analysisEnd)
              .startOf('day')
              .toDate(),
            labSampleAnalysisId: this.labSampleAnalysisId,
            operationRegistryId: this.operationId,
          };
          delete valuesData.symbol;
          delete valuesData.symbolType;
          delete valuesData.symbolLot;

          if (this.currentValues && this.currentValues.id) {
            await samplesApi.updateSampleOperationValues(
              this.currentValues.id,
              valuesData
            );
          } else {
            await samplesApi.insertSampleOperationValues(valuesData);
          }
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('global.success'),
          });
          this.$emit('dialogClose', { success: true });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      async populateInitialValues() {
        if (this.currentValues) {
          const {
            value,
            LD,
            LQ,
            U,
            symbol,
            symbolType,
            symbolLot,
            analysisStart,
            analysisEnd,
            measureId,
            measure,
            notes,
            recoveryFactor,
          } = this.currentValues;
          this.formData = {
            value: value || '',
            LD: LD || '',
            LQ: LQ || '',
            U: U || '',
            symbolLot: symbolLot || '',
            symbol: symbol || '',
            symbolType: symbolType || '',
            measureId,
            measure,
            analysisStart: analysisStart
              ? moment.utc(analysisStart).startOf('day').toDate()
              : '',
            analysisEnd: analysisEnd
              ? moment.utc(analysisEnd).startOf('day').toDate()
              : '',
            notes: notes || '',
            recoveryFactor: recoveryFactor || null,
          };
        } else if (this.currentOperation.mainOpMeasure) {
          this.formData = {
            ...this.formData,
            symbolType: this.currentOperation.symbolType || '',
            measure: this.currentOperation.mainOpMeasure || null,
            measureId: this.currentOperation.mainOpMeasure.id || null,
          };
        }
      },
      parseDecimal(value) {
        if (value == null || value === '') return null;
        return parseFloat(String(value).replace(',', '.'));
      },
      abortInsert() {
        this.$emit('dialogClose', { success: false });
      },
      updateSpecification(specification) {
        this.specification = specification;
      },
    },
    created() {
      this.populateInitialValues();
    },
  };
</script>
